export default __webpack_public_path__ + "static/media/go.4a9e07d8.png";